<script setup lang="ts">
import { defineProps, defineEmits, ref } from "vue";
import commonProps from "../props/commonProps";

const selectedOption = ref({ value: "", text: "" });

defineProps(commonProps);
const emit = defineEmits(["update:modelValue"]);

const onInput = (event: Event) => {
  const target = event.target as HTMLSelectElement;

  selectedOption.value = {
    value: target.value,
    text: target.options[target.selectedIndex].text,
  };

  emit("update:modelValue", selectedOption.value);
};
</script>

<template>
  <div>
    <label v-if="$attrs.label" :class="{ required: $attrs.required }">
      {{ $attrs.label }}
    </label>
    <select
      class="form-select form-control"
      :value="modelValue.value"
      v-bind="{
        ...$attrs,
        onChange: onInput,
      }"
    >
      <option v-if="$attrs.showEmptyOption !== false" disabled value="">
        {{ $attrs.placeholder || "Selecione uma das Opções" }}
      </option>
      <option
        v-for="({ value, label }, index) in options"
        :key="index"
        :value="value"
      >
        {{ label }}
      </option>
    </select>
  </div>
</template>
